import { render, staticRenderFns } from "./RubricSalOutBillList.vue?vue&type=template&id=06b0e8ac&scoped=true&"
import script from "./RubricSalOutBillList.vue?vue&type=script&lang=js&"
export * from "./RubricSalOutBillList.vue?vue&type=script&lang=js&"
import style0 from "./RubricSalOutBillList.vue?vue&type=style&index=0&id=06b0e8ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b0e8ac",
  null
  
)

export default component.exports